import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {HttpService} from "../http/HttpService";
import {
    Account,
    AccountBalanceResult,
    AccountTransferRequest, Currency,
    ListAccountsRequest,
    ListTransactionsRequest,
    ListUsersResponse,
    Transaction,
    TransactionResult,
    TransferRequest,
    ListTranslationsResponse
} from "../http/protocol";



export class WalletService extends AbstractAdminEntityService<AccountBalanceResult, ListUsersResponse> implements WalletService{

    constructor(http : HttpService) {
        super("/wallet", http);
    }

    getAccountBalances(userId:string):Promise<AccountBalanceResult[]> {
        return this.http.get(this.entityPath + "/balances/"+userId);
    }

    getAccountBalance(accountId:string):Promise<AccountBalanceResult> {
        return this.http.get(this.entityPath + "/account/balance/"+accountId);
    }

    getAccount(accountId:string):Promise<Account> {
        return this.http.get(this.entityPath + "/account/"+accountId);
    }

    getAccountList(request:ListAccountsRequest):Promise<Account[]> {
        return this.http.post(this.entityPath + "/account/list",request);
    }

    /* Use permission MANUAL_BALANCE_ADJUSTMENT without role*/
    transfer(request : TransferRequest) : Promise<TransactionResult>{
        return this.http.post(this.entityPath + "/transfer", request);
    }
    /* Use permission MANUAL_BONUS_BALANCE_ADJUSTMENT with role*/
    transferBonus(request : TransferRequest) : Promise<TransactionResult>{
        return this.http.post(this.entityPath + "/transfer/bonus", request);
    }
    transferBetweenAccounts(request : AccountTransferRequest) : Promise<TransactionResult> {
        return this.http.post(this.entityPath + "/account-transfer", request)
    }

    getSupportedCurrencies():Promise<Currency[]> {
        return this.http.get(this.entityPath + "/account/currencies/list");
    }

    getCurrency(code:string):Promise<Currency> {
        return this.http.get(this.entityPath + "/account/currencies/"+code);
    }

    createOrUpdateCurrency(currency: Currency, createSystemAccounts: boolean): Promise<Currency> {
        return this.http.post(this.entityPath + "/account/currencies/edit?createSystemAccounts=" + createSystemAccounts, currency);
    }

    removeCurrency(code:string):Promise<{}> {
        return this.http.delete(this.entityPath + "/account/currencies/remove/"+code);
    }

    getTransactionList(request:ListTransactionsRequest):Promise<ListTranslationsResponse> {
        return this.http.post(this.entityPath + "/transaction/list",request);
    }

}